import { render } from "./Myprofile.vue?vue&type=template&id=3c271a46&scoped=true"
import script from "./Myprofile.vue?vue&type=script&lang=js"
export * from "./Myprofile.vue?vue&type=script&lang=js"

import "./Myprofile.vue?vue&type=style&index=0&id=3c271a46&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3c271a46"

export default script